const containerStyles = {
    marginTop: '7.5rem',
    marginLeft: '34rem',
    marginRight: '20rem'
};

const selectionBrokerageStyle = {
    maxWidth:'400px',
    minWidth: '300px',
    minHeight: '420px',
    margin: '0 auto',
    // eslint-disable-next-line max-len
    boxShadow: '0 13px 35px -12px rgba(0, 0, 0, 0.56), 0 1px 22px 0px rgba(0, 0, 0, 0.12), 0 5px 7px -5px rgba(0, 0, 0, 0.2)',
    zIndex: 1
};

const footerIconStyles = {
    textAlign: 'center',
    color: '#777777',
    textDecoration:'none',
    marginTop: '2em',

};

const LoginButton = {
    color: '#292b2c',
    background: '#F5F5F5',
    borderColor: '#d0d0d0'
};

export {
    containerStyles,
    selectionBrokerageStyle,
    LoginButton,
    footerIconStyles
}